import { render, staticRenderFns } from "./ReadDocument.vue?vue&type=template&id=5aaa8bdc&"
import script from "./ReadDocument.vue?vue&type=script&lang=js&"
export * from "./ReadDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports